"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseArrowsIcon = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const CollapseArrowsIcon = (_a) => {
    var { fill = ui_components_1.baseColors.primaryAccentGreen800, stroke = ui_components_1.baseColors.primaryGreen300 } = _a, props = __rest(_a, ["fill", "stroke"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("rect", { y: "0.348267", width: "24", height: "24", rx: "4", fill: fill }), react_1.default.createElement("path", { id: "Vector 142", d: "M5 21.3483L11.2191 16.0177C11.6684 15.6325 12.3316 15.6325 12.7809 16.0177L19 21.3483", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" }), react_1.default.createElement("path", { id: "Vector 143", d: "M5 3.34827L11.2191 8.67888C11.6684 9.06407 12.3316 9.06407 12.7809 8.67888L19 3.34827", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" })));
};
exports.CollapseArrowsIcon = CollapseArrowsIcon;
exports.default = exports.CollapseArrowsIcon;
